webpackJsonp([8],{

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUrl = '';

if (false) {
  baseUrl = '/urlsec';
} else if (location.hostname.includes('sparta')) {
  baseUrl = '//cgiurlsec.sparta.html5.qq.com';
} else {
  baseUrl = '//cgi.urlsec.qq.com';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  validUrlAsync: baseUrl + '/index.php?m=url&a=validUrl',
  uploadImg: baseUrl + '/index.php?m=uploadFile&a=upload',
  postUrlComplain: baseUrl + '/index.php?m=urlComplain&a=addItem',
  getWebsiteClass: baseUrl + '/index.php?m=url&a=getWebsiteClass',
  getUrlComplainStatus: baseUrl + '/index.php?m=urlComplain&a=getComplainStatus',
  addCert: baseUrl + '/index.php?m=urlComplain&a=reSubmitCertificate',
  checkSiteIdentify: baseUrl + '/index.php?m=url&a=checkSiteIdentify',
  identifySite: '//siteident.urlsec.qq.com/identifySite',
  identifySiteLater: baseUrl + '/identification/index.php?m=url&a=identifySiteLater',

  checkWechatUser: '/wechat/urlcomplain/checkWechatUser',

  getSmsCode: baseUrl + '/index.php?m=urlComplain&a=getSmsCode',
  checkSmsCode: baseUrl + '/index.php?m=url&a=checkSmsCode'
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__message_vue__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(86);




var defaultProps = {
  content: '',
  duration: '3'
};

function notice(props) {
  var Instance = new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
    data: props,
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_1__message_vue___default.a, {
        props: props
      });
    }
  });

  var component = Instance.$mount();
  document.body.appendChild(component.$el);

  setTimeout(function () {
    document.body.removeChild(component.$el);
    props.onClose && props.onClose();
  }, 1000 * props.duration);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  info: function info(props) {
    props.type = 'info';
    return notice(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultProps, props));
  },
  warning: function warning(props) {
    props.type = 'warning';
    return notice(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultProps, props));
  },
  success: function success(props) {
    props.type = 'success';
    return notice(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultProps, props));
  },
  error: function error(props) {
    props.type = 'error';
    return notice(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultProps, props));
  }
});

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NotFoundComponent__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NotFoundComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_NotFoundComponent__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2__components_NotFoundComponent___default.a
  }, {
    alias: '/',
    path: '/urlcomplain',
    name: 'urlcomplain',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(499)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    alias: '/',
    path: '/urlcomplain/add_cert',
    name: 'add_cert',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(497)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/urlcomplain/site_certify',
    name: 'site_certify',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(503)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/urlcomplain/submit_success',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(501)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/urlcomplain/query_status',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(500)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/urlcomplain/form',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(502)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/urlcomplain/anxin',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(498)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}));

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this,
    _arguments = arguments;

/* harmony default export */ __webpack_exports__["a"] = ({
  debounce: function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function later() {
      var last = Date.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function () {
      context = _this;
      args = _arguments;
      timestamp = Date.now();

      var callNow = immediate && !timeout;

      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  },
  getCookie: function getCookie(name) {
    var returnvalue = "",
        end;
    if (document.cookie.length > 0) {
      var sd = document.cookie.indexOf(name);
      if (sd != -1) {
        sd += name.length + 1;
        end = document.cookie.indexOf(";", sd);
        if (end == -1) end = document.cookie.length;
        returnvalue = decodeURIComponent(document.cookie.substring(sd, end));
      }
    }
    return returnvalue;
  }
});

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(466)

var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(484),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(464)

var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(482),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(463)

var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(481),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(469)

var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(487),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fastclick__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_toast_index_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_loading_index_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cgi__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_function__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Message__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_qs__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_qs__);















var isDev = "production" === 'development';
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.xsrfCookieName = 'cloudsafetoken';
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.xsrfHeaderName = 'X-CRSF-TOKEN';

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$cgi = __WEBPACK_IMPORTED_MODULE_8__cgi__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$Message = __WEBPACK_IMPORTED_MODULE_10__components_Message__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$getCookie = __WEBPACK_IMPORTED_MODULE_9__utils_function__["a" /* default */].getCookie;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_loading_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_fastclick___default.a.attach(document.body);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = isDev;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$isDev = isDev;

var beacon = new BeaconAction({
  appkey: 'JS08SANX3T6GJ6',
  versionCode: '1.0.1',
  channelID: 'channel',
  openid: 'openid',
  delay: 0,
  sessionDuration: 60 * 1000 });
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.beacon = beacon;

var lrsmBeacon = new BeaconAction({
  appkey: '0WEB0KYEDG4JFF6T',
  channelID: 'channel',
  openid: 'openid',
  delay: 0,
  sessionDuration: 60 * 1000 });
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.lrsmBeacon = lrsmBeacon;

var lrsmReport = function lrsmReport(eventName) {
  __WEBPACK_IMPORTED_MODULE_7_axios___default()({
    url: 'https://bma.urlsec.qq.com/rw-online/ext',
    method: 'post',
    withCredentials: false,
    data: {
      Action: 'InsertEvent',
      RequestId: Math.floor(Math.random() * 100000) + '',
      EventName: eventName,
      Origin: 'QQ'
    }
  });
};
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.lrsmReport = lrsmReport;

var _qs$parse = __WEBPACK_IMPORTED_MODULE_11_qs___default.a.parse(location.search.slice(1)),
    src = _qs$parse.src;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$http = function (url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof url === 'string') {
    options.url = url;
  } else {
    options = url;
  }

  if (!options.params) {
    options.params = { src: src };
  } else if (!options.params.src) {
    options.params.src = src;
  }

  return __WEBPACK_IMPORTED_MODULE_7_axios___default()(options).then(function (resp) {
    var _resp$data = resp.data,
        reCode = _resp$data.reCode,
        data = _resp$data.data;


    if (reCode === -206 || reCode === -207 || reCode === -208) {
      location.href = '/wechat/urlcomplain#/urlcomplain/error?code=' + reCode + '&data=' + data;
    }

    return resp;
  });
};

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  }
}).$mount('#app-box');

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'divider'
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_router__ = __webpack_require__(133);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_router__["a" /* go */])(link, this.$router);
    }
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(234);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_router__ = __webpack_require__(133);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__libs_router__["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      src: 2,
      isAdmin: false,
      url: '' };
  },
  created: function created() {
    this.getQuery();
  },

  methods: {
    getQuery: function getQuery() {
      var _qs$parse = __WEBPACK_IMPORTED_MODULE_0_qs___default.a.parse(location.search.slice(1)),
          src = _qs$parse.src;

      this.src = parseInt(src) || this.$route.query.src || 2;
    },
    ensureIsAdmin: function ensureIsAdmin() {
      this.isAdmin = true;
    },
    handleUrlChange: function handleUrlChange(value) {
      this.url = value;
    }
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    content: {
      type: String
    },
    duration: {
      type: [Number, String],
      default: 3
    },
    type: {
      type: String,
      default: 'info'
    }
  }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_msg_index_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_msg_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_msg_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_divider_index_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_divider_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_divider_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    XButton: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_x_button_index_vue___default.a, Msg: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_msg_index_vue___default.a, Divider: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_divider_index_vue___default.a
  },
  data: function data() {
    var query = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.parse(location.search.slice(1));

    return {
      code: query.code || this.$route.query.code,
      msg: query.data || this.$route.query.data,
      title: '访问失败'
    };
  },

  computed: {
    description: function description() {
      if (this.code && this.msg) {
        var div = document.createElement("div");
        div.appendChild(document.createTextNode(this.msg));
        return div.innerHTML;
      } else {
        return '该网址可能出了些差错，请稍后重试';
      }
    }
  }
});

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-msg"
  }, [_c('div', {
    staticClass: "weui-msg__icon-area"
  }, [_c('i', {
    staticClass: "weui-icon_msg",
    class: ("weui-icon-" + (_vm.icon || 'success'))
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__text-area"
  }, [_c('h2', {
    staticClass: "weui-msg__title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-msg__desc"
  }, [_vm._t("description")], 2), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "weui-msg__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__opr-area"
  }, [_c('p', {
    staticClass: "weui-btn-area"
  }, [_vm._t("buttons", function() {
    return _vm._l((_vm.buttons), function(button) {
      return _c('a', {
        staticClass: "weui-btn",
        class: ("weui-btn_" + (button.type)),
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            return _vm.onClick(button.onClick, button.link)
          }
        }
      }, [_vm._v(_vm._s(button.text))])
    })
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "weui-btn",
    class: _vm.classes,
    style: (_vm.buttonStyle),
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.actionType
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.showLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e(), _vm._v(" "), _vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.text))]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style)
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "src": _vm.src,
      "url": _vm.url,
      "handleUrlChange": _vm.handleUrlChange,
      "isAdmin": _vm.isAdmin,
      "ensureIsAdmin": _vm.ensureIsAdmin
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['container', _vm.type]
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.content))])])
},staticRenderFns: []}

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('msg', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "icon": "warn"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "vux-divider"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(462)

var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(480),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(465)

var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(483),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(467)

var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(485),
  /* scopeId */
  "data-v-8224c940",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(468)

var Component = __webpack_require__(30)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(486),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[225]);


// WEBPACK FOOTER //
// app.76ef78117a5318886b35.js